module.exports = __webpack_public_path__ + "static/media/castoriginal.4c3a6fe8.svg";